import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-66187605")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["title-row", _ctx.$mq]
  }, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.titles, (title, index) => {
      return (_openBlock(), _createBlock("div", {
        class: "title-column",
        key: 'title-'+index,
        style: _ctx.styles[index]
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(title.names, (name, nameIndex) => {
          return (_openBlock(), _createBlock("div", {
            key: 'title-'+index+'-'+nameIndex
          }, _toDisplayString(name), 1))
        }), 128))
      ], 4))
    }), 128))
  ], 2))
})